var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeightArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9368 5.83333C11.3971 5.83333 11.7702 5.46024 11.7702 5C11.7702 4.53976 11.3971 4.16667 10.9368 4.16667H0.936849C0.476612 4.16667 0.103516 4.53976 0.103516 5C0.103516 5.46024 0.476612 5.83333 0.936849 5.83333H10.9368Z",
    fill: "#252A31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18093 8.57741C5.85549 8.90285 5.85549 9.43048 6.18093 9.75592C6.50636 10.0814 7.034 10.0814 7.35944 9.75592L11.5261 5.58926C11.8515 5.26382 11.8515 4.73618 11.5261 4.41074L7.35944 0.244078C7.034 -0.0813592 6.50636 -0.0813592 6.18093 0.244078C5.85549 0.569515 5.85549 1.09715 6.18093 1.42259L9.75834 5L6.18093 8.57741Z",
    fill: "#252A31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightArrowRight);
export default __webpack_public_path__ + "static/media/WeightArrowRight.1a089460.svg";
export { ForwardRef as ReactComponent };